import React from 'react';
import classnames from 'classnames';

import { SimpleContainer, SidesContainer } from '../components/Container';
import SectionHeading from './SectionHeading';

import * as css from './Press.module.css';
import * as grid from '../styles/grid.module.css';

const Press = ({ quotes = [] }) => {
  return (
    <>
      <SimpleContainer bottomLine className={css.beforeTitle}></SimpleContainer>

      <SectionHeading bottomLine>Press</SectionHeading>
      {quotes.map(({ quote, heading, url, subheading, date }, i) => {
        return (
          <SidesContainer
            topLine={false}
            bottomLine={true}
            className={css.item}
            tag="figure"
            tagClassName={css.row}
            key={`${quote}-${i}`}
          >
            <figcaption className={classnames(grid.col, css.info)}>
              {heading && (
                <p className={css.heading}>
                  {url ? (
                    <a href={url} target="_blank" rel="noreferrer">
                      {heading}
                    </a>
                  ) : (
                    heading
                  )}
                </p>
              )}
              {(subheading || date) && (
                <p>
                  {subheading}
                  {date && subheading && ', '}
                  {date}
                </p>
              )}
            </figcaption>
            <div className={classnames(grid.col, css.quote)}>
              <blockquote>
                <p>{quote}</p>
              </blockquote>
            </div>
          </SidesContainer>
        );
      })}
    </>
  );
};

export default Press;
